import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { SimulationInfo } from '@classes/simulation/simulation-info';
import { ExportType } from '@enums/export-type.enum';
import { UserService } from '@services/user.service';
import { UserParameter } from '@classes/user-parameter';
import { ReportMode } from '@enums/report-mode.enum';
import { PartitioningType } from '@enums/partitioning-type.enum';
import { SimulationVisibilityType } from '@enums/simulation-visibility-type.enum';
import { ReportSelectGroup } from '@classes/report/report-select-group';
import { UiService } from '@services/ui.service';
import { SimulationService } from '@services/simulation.service';
import { OriginService } from '@services/origin.service';

@Component({
  selector: 'app-report-simu',
  templateUrl: './report-simu.component.html',
  styleUrls: ['./report-simu.component.scss']
})
export class ReportSimuComponent implements OnInit, OnDestroy {
    private userParamSub: Subscription;

    simulations: ReportSelectGroup[];
    isCrac: boolean;
    cracCodes = [PartitioningType.sicCrac, PartitioningType.sicBxl, PartitioningType.sicPrevision, PartitioningType.sicCrac2022];
    exportType: ExportType;
    reportMode = ReportMode;
    years: number[];

    constructor(
        private userSrv: UserService,
        private route: ActivatedRoute,
        private uiSrv: UiService,
        private originSrv: OriginService,
        private simulationSrv: SimulationService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
        this.simulationSrv.referenceYear = -1;
    }

    private initSubscriptions(): void {
        this.originSrv.get()
        .subscribe(origin => {
            if (origin.provider.code !== 'bbc2020')
            {
                this.years = origin.lastYears
                    .map(y => y.year)
                    .filter((value, index, self) => self.indexOf(value) === index) // distinct
                    .sort();
            }
        });

        this.route.data
        .subscribe((data: {simulations: SimulationInfo[]}) => {
            const template = {
                label: this.uiSrv.translate('reports.compare.list.template.default.shortLabel'),
                items: data.simulations.filter(s => s.visibility === SimulationVisibilityType.template && !s.isMJP)
            };
            const templateMjp = {
                label: this.uiSrv.translate('reports.compare.list.template.mjp.shortLabel'),
                items: data.simulations.filter(s => s.visibility === SimulationVisibilityType.template && s.isMJP)
            };
            const perso = {
                label: this.uiSrv.translate('reports.compare.list.perso.shortLabel'),
                items: data.simulations.filter(s => s.visibility === SimulationVisibilityType.perso)
            };
            this.simulations = [template];
            if (templateMjp.items.length > 0) {
                this.simulations.push(templateMjp);
            }
            if (perso.items.length > 0) {
                this.simulations.push(perso);
            }
        });

        this.userParamSub = this.userSrv.userParametersSubject
        .subscribe(parameters => {
            this.testCracType(parameters);
        });
    }

    private testCracType(parameters: UserParameter): void {
        this.isCrac = false;
        const userPartCode = parameters ? parameters.origin.selectedPartitioning.code.toLowerCase() : '';
        const indexFound = this.cracCodes.findIndex(c => c === userPartCode);

        if(indexFound !== -1) {
            this.isCrac = true;
            this.exportType = indexFound === 1 ? ExportType.bxl : ExportType.crac;
        }
    }

    ngOnDestroy() {
        if(this.userParamSub) {
            this.userParamSub.unsubscribe();
        }
        this.simulationSrv.referenceYear = null;
    }
}
